import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Config } from '../../services/config';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SnackbarService {
    conf: MatSnackBarConfig;

    constructor(
        public snackbar: MatSnackBar,
        public config: Config,
        private translate: TranslateService,
    ) {
        this.conf = Object.assign(new MatSnackBarConfig(), this.config.get('snackbar'));
    }

    public dismiss() {
        this.snackbar.dismiss();
    }

    public success(message) {
        message = this.translate.instant(message);
        const conf = JSON.parse(JSON.stringify(this.conf));
        conf.panelClass.push('Snackbar--success');

        return this.open(message, '', conf);
    }

    public error(message) {
        const conf = JSON.parse(JSON.stringify(this.conf));
        conf.panelClass.push('Snackbar--error');

        return this.open(message, '', conf);
    }

    public warning(message) {
        const conf = JSON.parse(JSON.stringify(this.conf));
        conf.panelClass.push('Snackbar--warning');

        return this.open(message, '', conf);
    }

    private open(message, title, conf) {
        return this.snackbar.open(message, title, conf);
    }
}
